<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Admin Leave
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <label class="Label">Branch <span class="text-danger">*</span></label>
                <ng-select name="branch" [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="Filter.BranchId" (change)="ComboLoad('Client');clear()" placeholder="Select Branch">
                </ng-select>
            </div>

            <div class="col-md-6">
                <label class="Label">Client</label>
                <ng-select name="client" [items]="Clients" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                    [(ngModel)]="Filter.ClientId" (change)="ComboLoad('Site');clear()" placeholder="Select Client">
                </ng-select>
            </div>

            <div class="col-md-6">
                <label class="Label">Site</label>
                <ng-select name="site" [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="Filter.SiteId" placeholder="Select Site" (change)="clear()">
                </ng-select>
            </div>
        </div>
        <div class="row mt-1">
            <div class="col-md-6">
                <label class="Label">Employee Code</label>
                <input name="Employeecode" type="text" class="form-control" [(ngModel)]="Filter.EmpCode"
                    placeholder="Employee Code" />
            </div>

            <div class="col-auto mt-4">
                <button (click)="ComboLoad('EmpLoadForRegularization')" class="btn btn-primary btn-sm"> <i class="bi bi-search"></i> Load</button>
            </div>
        </div>

        <div class="mt-4">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead>
                    <tr>
                        <th [ngClass]="{'colHide': !this.common.PageRight.IsEdit}" scope="col">Action</th>
                        <th scope="col">Employee</th>
                        <th scope="col">Client Name</th>
                        <th scope="col">Site Name</th>
                        <th scope="col">Shift</th>
                        <th scope="col">Duty</th>
                        <!-- <th scope="col">In Time</th>
                            <th scope="col">Out Time</th> -->
                        <!-- <th scope="col">Remark</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr style="font-size: 11px;" *ngFor="let data of TableDatas; let i = index">
                        <td [ngClass]="{'colHide': !this.common.PageRight.IsEdit}"
                            [routerLink]="['/request/adminleave/', data['EmpMasterID']]"
                            style="text-align: center;"><i class="bi bi-pencil-square text-warning cursor-pointer"></i>
                        </td>
                        <td>
                            <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                <div class="col userdetail">
                                    <span class="text-label">{{data['Name']}}</span><br />
                                    <span class="text-label-light">#{{data['EmpCode']}}</span><br />
                                    <span class="text-label-light">{{data['DesignationName']}}</span>
                                </div>
                            </div>
                        </td>
                        <td>{{data['ClientName']}}</td>
                        <td>{{data['SiteName']}}</td>
                        <td>{{data['ShiftName']}}</td>
                        <td>{{data['DutyName']}}</td>
                        <!-- <td>InTime</td>
                            <td>OutTime</td> -->
                        <!-- <td></td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>